<template>
  <div class="u-shadow-bottom bgc-white bdrs10 p20 mt25">
    <div v-html="propContentHtml" class="u-markDown"></div>
  </div>
</template>

<script>
export default {
  props: {
    propContentHtml: String,
  },
}
</script>
